import type { GetUser } from '@messenger/types'
import axios from '@/api/axios.config'

export const user = async () => {
  return await axios.get<GetUser>('/user')
}
